/**
 * Map a tap's x within the hit overlay to a data-domain x. The overlay is laid out to exactly cover
 * the graph plot (same width, same center), so its local x maps linearly onto `[xMin, xMax]`.
 * Anchoring the mapping to the overlay's own measured width avoids drift when the graph and overlay
 * widths diverge on narrow viewports.
 */
export function overlayDataX(locationX: number, overlayWidth: number, xMin: number, xMax: number): number {
  if (overlayWidth <= 0) {
    return xMin
  }

  const clampedX = Math.max(0, Math.min(overlayWidth, locationX))

  return xMin + (clampedX / overlayWidth) * (xMax - xMin)
}
